import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, switchMap, catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { StorageService } from '../services/storage/storage.service';
import { SessionClearService } from '../services/session/session-clear.service';
import { inject } from '@angular/core';

function handleRefreshToken(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  storage: StorageService,
  auth: AuthService,
  sessionClear: SessionClearService
): Observable<HttpEvent<unknown>> {
  let receivedRefreshToken: string | null = null;

  return auth.refreshToken().pipe(
    switchMap((data: any) => {
      storage.setDataLogin(data);
      receivedRefreshToken = data?.refreshToken ?? null;
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${data?.token}`
        }
      });
      return next(clonedReq);
    }),
    catchError((error) => {
      const savedRefresh = storage.getRefreshToken();
      if (savedRefresh && savedRefresh === receivedRefreshToken) {
        return next(req);
      } else {
        void sessionClear.clearSessionAndNavigate();
        return throwError(() => error);
      }
    })
  );
}

function handleAuthError(
  err: unknown,
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  storage: StorageService,
  auth: AuthService,
  sessionClear: SessionClearService
): Observable<HttpEvent<unknown>> {
  if (err instanceof HttpErrorResponse) {
    if (err.status === 401) {
      if (req.url.includes('auth/refresh-token')) {
        void sessionClear.clearSessionAndNavigate();
        return throwError(() => err);
      }
      return handleRefreshToken(req, next, storage, auth, sessionClear);
    }
  }
  return throwError(() => err);
}

export const refreshTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const storage = inject(StorageService);
  const auth = inject(AuthService);
  const sessionClear = inject(SessionClearService);

  const isExcluded =
    (req.url.includes('/auth') ||
     req.url.includes('ipify'));

  if (isExcluded) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err) => handleAuthError(err, req, next, storage, auth, sessionClear))
  );
};
